import { Navigate, Route, Routes } from "react-router-dom";
import LoginPage from "../screens/login/LoginPage";
import OidcAuth from "../screens/login/OidcAuth";
import AzureAuth from "../screens/login/AzureAuth";
import RegisterPage from "../screens/register/RegisterPage";
import NoPermission from "../NoAccess/NoPermission";

export const PublicRoutes = () => {
  return (
    <Routes>
      <Route path="login" element={<LoginPage />} />
      <Route path="noaccess" element={<NoPermission />} />
      <Route path="auth" element={<OidcAuth />} />
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
};
